<li class="news-item">
    <a href="{{ item?.LinkURL }}">
        <span class="news-date">{{ item?.DisplayOn | date }}</span>
        <span class="news-title"
              [matTooltip]="item?.TitleTooltip"
              matTooltipPosition="above"
              [innerHtml]="item?.Title | safe:'html'"></span>
        <div class="news-content-item news-subtitle">{{ item?.SubTitle }}</div>
        <div class="news-content-item news-content" [innerHtml]="item?.Content | safe:'html'"></div>
    </a>
</li>
